import { useRouter } from 'next/router';
import { useMemo } from 'react';

import Button from '~components/Button';
import { WEB_URL } from '~constant/env';
import useGetCompanyInfo from '~hooks/query/company/useCompanyInfo';
import useGetIndustryByCode from '~hooks/useGetIndustryByCode';
import useMedia from '~hooks/useMedia';
import useMoveOneIdPage from '~hooks/useMoveOneIdPage';
import { useRouterQuery } from '~hooks/useRouterQuery';
import { setGtmDataLayer } from '~utils/common/thirdPartyEvent';

import ButtonGroup from '../ButtonGroup';
import { S } from '../style';

function SignupNudgeChart() {
  const router = useRouter();
  const { isMobile } = useMedia();
  const moveOneIdPage = useMoveOneIdPage();
  const companyId = useRouterQuery('companyId');
  const { data } = useGetCompanyInfo(companyId);

  const videoAssetName = useMemo(() => {
    if (isMobile) {
      return 'video-barchart-years-m';
    }

    return 'video-barchart-years';
  }, [isMobile]);
  const { getIndustryByCode } = useGetIndustryByCode();
  const { data: companyInfo } = useGetCompanyInfo(companyId);

  const handleClick = () => {
    setGtmDataLayer('company__avgServiceYear__login__click', {
      companyName: companyInfo?.name,
      companyType: companyInfo?.category,
      companyIndustry: companyInfo?.industryCode
        ? getIndustryByCode(companyInfo?.industryCode)?.name
        : '',
      companyHash: companyId,
    });

    moveOneIdPage({
      beforeUrl: `${WEB_URL}${router.asPath}#employee-barchart`,
      messageKey: 'kreditjob_company_bookmark_title',
    });
  };

  return (
    <S.SignupNudgeWrapper onClick={() => handleClick()}>
      <S.VideoWrapper>
        {videoAssetName && (
          <S.Video key={videoAssetName} autoPlay loop muted playsInline>
            <source
              key={`/images/${videoAssetName}.webm`}
              src={`/images/${videoAssetName}.webm`}
              type='video/webm'
            />
            <source
              key={`/images/${videoAssetName}.mp4`}
              src={`/images/${videoAssetName}.mp4`}
              type='video/mp4'
            />
          </S.Video>
        )}
        <S.MessageWrapper>
          <S.Message typography='midium150_C1'>
            {data?.name}의 <br />
            평균 근속연수 변동 추이가 궁금하다면?
          </S.Message>
          <Button variant='magenta' size='sm'>
            로그인
          </Button>
        </S.MessageWrapper>
      </S.VideoWrapper>
      <ButtonGroup currentYear={2021} />
    </S.SignupNudgeWrapper>
  );
}

export default SignupNudgeChart;
